/**
 * iOS Safari opens the keyboard only for a `focus()` made during the tap
 * itself, and the command palette mounts its input after the tap, so its
 * own focus came too late and the keyboard stayed down. Focusing a hidden
 * input inside the tap opens the keyboard; the palette then moves focus to
 * its real input, which keeps the keyboard up. The stand-in removes itself
 * once it loses focus (or after a second, if nothing took it).
 */
export function holdKeyboard() {
  const input = document.createElement("input");
  input.setAttribute("aria-hidden", "true");
  input.tabIndex = -1;
  // In the viewport so iOS does not scroll to it; 16px so it does not zoom.
  input.style.cssText =
    "position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;border:0;padding:0;font-size:16px;";
  document.body.appendChild(input);
  input.focus();
  input.addEventListener("blur", () => input.remove(), { once: true });
  setTimeout(() => input.remove(), 1000);
}
